import { ESecondCategories } from '@/domains/investor/const/SecondCategories.enum'
import { EMainCategories } from '@/domains/investor/const/MainCategories.enum'
import type { IDataViewHeaderConfig } from '../../components/DataView/DataView.types'
export { ITEMS_PER_PAGE } from '@/domains/investor/components/DataView/DataView.const'

export const MERGER_OF_COMPANIES_CATEGORIES = [
  ESecondCategories.MERGER_OF_COMPANIES,
]

export const MERGER_OF_COMPANIES_CATEGORIES_SCOPE = {
  mainCategories: [EMainCategories.REPORT, EMainCategories.PRESENTATION],
  allowedSecondCategories: MERGER_OF_COMPANIES_CATEGORIES,
}

export const MERGER_OF_COMPANIES_HEADER_CONFIG: IDataViewHeaderConfig = {
  text: '',
}
